//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueCropper from "vue-cropperjs";
import GenericModal from "../generic-modal.vue";
import PictureCropperToolbar from "./picture-cropper-toolbar.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PictureCropper",
  components: {
    GenericModal,
    VueCropper,
    PictureCropperToolbar
  },
  props: {
    file: {
      type: [File, null],
      required: true
    }
  },
  data() {
    return {
      zoomStep: 0.2,
      rotateDegrees: 90,
      croppedImageWidth: 200,
      croppedImageHeight: 200
    };
  },
  methods: {
    initCropper() {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.$refs.cropper.replace(reader.result);
      }, false);
      reader.readAsDataURL(this.file);
    },
    handleModalShown() {
      this.initCropper();
    },
    handleModalHidden() {
      this.$emit("hidden");
    },
    handleSavePicture() {
      this.$refs.cropper.getCroppedCanvas({
        width: this.croppedImageWidth,
        height: this.croppedImageHeight
      }).toBlob(blob => {
        this.$emit("cropped", blob);
      });
    },
    zoomCropper(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    resetCropper() {
      this.$refs.cropper.reset();
    },
    rotateCropper(deg) {
      this.$refs.cropper.rotate(deg);
    },
    handleToolbarAction(action) {
      switch (action) {
        case "zoom-in":
          this.zoomCropper(this.zoomStep);
          break;
        case "zoom-out":
          this.zoomCropper(this.zoomStep * -1);
          break;
        case "rotate-left":
          this.rotateCropper(this.rotateDegrees * -1);
          break;
        case "rotate-right":
          this.rotateCropper(this.rotateDegrees);
          break;
        case "reset":
          this.resetCropper();
          break;
      }
    }
  }
});